const defaultFormState = {
  number: '+1',
  assignedTo: '',
  company: '',
  allowedUsers: [],
  huntPorts: [],
};

const numberFormState = (state = defaultFormState, action) => {
  switch (action.type) {
    case 'EDIT_NUMBER_SHOW': {
      const { boxToBoxHuntNumber, ...number } = action.number || {};
      return number;
    }
    case 'EDIT_BOX_NUMBER_SHOW': {
      const { boxToBoxHuntNumber, ...number } = action.number || {};
      return number;
    }
    case 'EDIT_NUMBER_FIELD_CHANGE':
      return {
        ...state,
        ...{ [action.name]: action.value },
      };
    case 'EDIT_NUMBER_FIELD':
      return { ...state, [action.name]: action.value };
    case 'EDIT_NUMBER_SUCCESS':
    case 'UPDATE_NUMBER_SUCCESS':
    case 'EDIT_NUMBER_CANCEL':
      return defaultFormState;
    default:
      return state;
  }
};

export default numberFormState;
